/* Street Garms SG-048 — mobile header-strip density experiment.
 * Preview/test URLs:
 *   ?sg_header=control  -> current announcement + Trustpilot/Klarna/Clearpay strip
 *   ?sg_header=compact  -> 34px commercial announcement + 30px Trustpilot/Klarna/Clearpay strip
 *   ?sg_header=auto     -> 50/50 session-level assignment
 * No parameter uses the approved compact treatment; ?sg_header=control preserves the original stack for comparison.
 *
 * Tracking hooks use dataLayer + CustomEvent only and make no third-party requests.
 */
(function () {
  'use strict';

  var EXPERIMENT = 'SG-048';
  var PARAM = 'sg_header';
  var VALID = ['control', 'compact'];
  var exposureSent = false;

  function normalise(value) {
    value = String(value || '').toLowerCase().trim().replace(/-/g, '_');
    if (value === 'a' || value === 'control' || value === 'current' || value === 'stack') return 'control';
    if (value === 'b' || value === 'compact' || value === 'reduced' || value === 'lean') return 'compact';
    return '';
  }

  function variant() {
    return normalise(document.documentElement.getAttribute('data-sg048-header')) || 'compact';
  }

  function isMobile() {
    return window.matchMedia ? window.matchMedia('(max-width: 749px)').matches : window.innerWidth <= 749;
  }

  function push(eventName, selected, extra) {
    var payload = {
      event: eventName,
      sg_experiment_id: EXPERIMENT,
      sg_header_variant: selected
    };
    if (extra) Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function dispatch(eventName, selected, extra) {
    try {
      window.dispatchEvent(new CustomEvent(eventName, {
        detail: Object.assign({ experiment: EXPERIMENT, variant: selected }, extra || {})
      }));
    } catch (e) {}
  }

  function metrics() {
    var announcement = document.querySelector('#shopify-section-announcement-bar .t4s-announcement-bar:not(.t4s-d-none)');
    var header = document.querySelector('.t4s-section-header');
    var topbar = document.querySelector('#shopify-section-top-bar .t4s-top-bar');
    var main = document.getElementById('MainContent');
    var announcementHeight = announcement ? Math.round(announcement.getBoundingClientRect().height) : 0;
    var headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0;
    var topbarHeight = topbar ? Math.round(topbar.getBoundingClientRect().height) : 0;
    var mainTop = main ? Math.max(0, Math.round(main.getBoundingClientRect().top + (window.scrollY || 0))) : 0;
    return {
      viewport_width: window.innerWidth || 0,
      viewport_height: window.innerHeight || 0,
      sg_announcement_height_px: announcementHeight,
      sg_header_height_px: headerHeight,
      sg_trust_strip_height_px: topbarHeight,
      sg_header_stack_height_px: announcementHeight + headerHeight + topbarHeight,
      sg_main_content_top_px: mainTop,
      sg_announcement_visible: announcement ? 1 : 0,
      page_type: document.body ? (document.body.className.match(/template-([^\s]+)/) || [,''])[1] : ''
    };
  }

  function sendExposure() {
    if (exposureSent || !isMobile()) return;
    exposureSent = true;
    var selected = variant();
    var extra = metrics();
    push('sg048_header_exposure', selected, extra);
    dispatch('sg:header-exposure', selected, extra);
  }

  function bindAnnouncementClose() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('#shopify-section-announcement-bar .t4s-announcement-bar__close');
      if (!button || !isMobile()) return;
      var selected = variant();
      var extra = metrics();
      push('sg048_announcement_close', selected, extra);
      dispatch('sg:announcement-close', selected, extra);
    }, true);
  }

  function bindTrustClick() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('#shopify-section-top-bar .sg-topbar-mobile a');
      if (!link || !isMobile()) return;
      var selected = variant();
      push('sg048_trust_signal_click', selected, metrics());
      dispatch('sg:trust-signal-click', selected, metrics());
    }, true);
  }

  function apply() {
    document.documentElement.setAttribute('data-sg048-experiment', EXPERIMENT);
    bindAnnouncementClose();
    bindTrustClick();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(sendExposure);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
